import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const relayTypes = [
  {
    title: 'SRT/SRTLA',
    price: '$9.99',
    description: 'Connection bonding for mobile streaming',
    link: 'https://irlhosting.com/whmcs/index.php?rp=/store/endpoint-relay-hosting/srt-relay',
    features: [
      'Stream in 4K/60fps up to 48Mb/s',
      'Access in less than 5 minutes',
      'Private Dedicated IP Address',
      'Unlimited Bandwidth',
      'IRLremote+ Access',
      'Perfect for Belabox, IRLbox, Moblin, IRLPro App and more!'
    ],
    accent: 'from-cyan-500 to-blue-500',
  },
  {
    title: 'RIST',
    price: '$5.99',
    description: 'Low-latency reliable transport',
    link: 'https://irlhosting.com/whmcs/index.php?rp=/store/endpoint-relay-hosting/rist-relay',
    features: [
      'Stream in 4K/60fps up to 48Mb/s',
      'Access in less than 5 minutes',
      'Private Dedicated IP Address',
      'Unlimited Bandwidth',
      'IRLremote+ Access',
      'Bond up to 10 Connections',
      'For IRLbox Encoder'
    ],
    accent: 'from-blue-500 to-purple-500',
  },
  {
    title: 'RTMP',
    price: '$9.99',
    description: 'Traditional streaming protocol',
    link: 'https://irlhosting.com/whmcs/index.php?rp=/store/endpoint-relay-hosting/rtmp-hosting',
    features: [
      'Stream in 4K/60fps up to 48Mb/s',
      'Access in less than 5 minutes',
      'Private Dedicated IP Address',
      'Unlimited Bandwidth',
      'IRLremote+ Access',
      'Used for LiveU Solo, DJI Cameras, Phone Screenshare and more!'
    ],
    accent: 'from-purple-500 to-pink-500',
  }
];

export function RelaySection() {
  return (
    <section id="relay" className="py-24 px-4 scroll-mt-20">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Relay Endpoints
          </h2>
          <p className="text-gray-400 text-lg">
            Deployed nearest to your location in under 5 minutes
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {relayTypes.map((relay, index) => (
            <motion.div
              key={relay.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group"
            >
              <div className="bg-gray-900/80 border border-gray-800 rounded-2xl p-6 h-full hover:border-gray-700 transition-colors flex flex-col">
                {/* Protocol name with gradient */}
                <div className={`text-2xl font-bold bg-gradient-to-r ${relay.accent} bg-clip-text text-transparent mb-2`}>
                  {relay.title}
                </div>
                
                {/* Price */}
                <div className="flex items-baseline gap-1 mb-3">
                  <span className="text-3xl font-bold text-white">{relay.price}</span>
                  <span className="text-gray-500 text-sm">/month</span>
                </div>
                
                {/* Description */}
                <p className="text-gray-400 text-sm mb-5">{relay.description}</p>
                
                {/* Features */}
                <ul className="space-y-2 mb-6 flex-grow">
                  {relay.features.map((feature) => (
                    <li key={feature} className="flex items-center text-sm text-gray-300">
                      <span className="w-1.5 h-1.5 bg-cyan-500 rounded-full mr-2.5" />
                      {feature}
                    </li>
                  ))}
                </ul>
                
                {/* CTA */}
                <a 
                  href={relay.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button 
                    variant="outline"
                    className="w-full border-gray-700 text-white hover:bg-gray-800 hover:border-gray-600"
                  >
                    Get Started
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}